import { ApiError } from './error.es.js';
export { ApiError } from './error.es.js';
import { fetchWithTimeout } from './helpers.es.js';
export { fetchWithTimeout } from './helpers.es.js';
import { globalTracer, FORMAT_HTTP_HEADERS } from 'opentracing';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizeSlashUrl = (baseURL = "", url) => {
  const normalizedBaseUrl = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;
  const normalizedPath = url.startsWith("/") ? url.slice(1) : url;
  return `${normalizedBaseUrl}/${normalizedPath}`;
};
const DEFAULT_ERROR_MESSAGE = "\u0110\xE3 c\xF3 l\u1ED7i x\u1EA3y ra, vui l\xF2ng th\u1EED l\u1EA1i sau!";
class Api {
  constructor(url, getError, defaultConfig = {}) {
    this.baseURL = url;
    this.interceptors = [];
    this.getError = getError;
    this.defaultConfig = defaultConfig;
  }
  _parseJson(response) {
    return response.text().then((text) => text ? JSON.parse(text) : null);
  }
  addInterceptor(interceptFn) {
    this.interceptors.push(interceptFn);
  }
  appendParamsToURL(url, params, flattenArray = false) {
    if (params) {
      const paramsArr = [];
      for (const k of Object.keys(params)) {
        if (params[k] !== null && params[k] !== void 0) {
          const paramK = params[k];
          if (Array.isArray(paramK) && flattenArray) {
            const flattenArrayString = paramK.map((element) => `${k}=${encodeURIComponent(element)}`).join("&");
            paramsArr.push(flattenArrayString);
          } else {
            paramsArr.push(`${k}=${encodeURIComponent(params[k])}`);
          }
        }
      }
      if (paramsArr.length > 0)
        url = `${url}?${paramsArr.join("&")}`;
    }
    return url;
  }
  async request(path, body, method, config = {}, flattenArray = false) {
    var _a;
    const {
      headers: configHeaders,
      params: configParams,
      timeout: configTimeout
    } = config;
    let headers = __spreadValues(__spreadValues({}, this.defaultConfig.headers), configHeaders);
    const url = this.appendParamsToURL(path, configParams || {}, flattenArray);
    let serializedBody = null;
    if (body) {
      if (typeof body !== "string") {
        if ("append" in body) ; else {
          serializedBody = JSON.stringify(body);
          headers = __spreadValues({
            "Content-Type": "application/json"
          }, headers);
        }
      } else {
        serializedBody = body;
      }
    }
    let serializedParams = null;
    if (configParams) {
      serializedParams = JSON.stringify(configParams);
    }
    const fetchUrl = url.startsWith("http") ? url : normalizeSlashUrl(this.baseURL, url);
    const tracer = globalTracer();
    const spanName = `[${method}] ${normalizeSlashUrl(this.baseURL, path)}`;
    const span = tracer.startSpan(spanName);
    tracer.inject(span, FORMAT_HTTP_HEADERS, headers);
    span.setTag("http.method", method);
    span.setTag("http.baseurl", this.baseURL);
    span.log({
      body: serializedBody,
      params: serializedParams
    });
    const requestObj = __spreadProps(__spreadValues({}, this.defaultConfig), {
      method,
      headers: new Headers(headers),
      body: serializedBody
    });
    this.interceptors.forEach((fn) => fn(requestObj));
    try {
      const res = await fetchWithTimeout(fetchUrl, requestObj, configTimeout);
      if (res && typeof res !== "string") {
        if (res.status >= 400) {
          const resp = await res.json();
          const error = ((_a = this.getError) == null ? void 0 : _a.call(this, resp)) || new ApiError(DEFAULT_ERROR_MESSAGE, res.status, resp);
          return Promise.reject(error);
        }
        const respHeaders = {};
        res.headers.forEach((val, key) => respHeaders[key] = val);
        const data = await this._parseJson(res);
        span.setTag("status", "success");
        span.finish();
        return {
          code: res.status,
          data,
          headers: respHeaders
        };
      }
      return { code: -1, headers: {}, data: {} };
    } catch (e) {
      span.setTag("status", "error");
      span.log({
        error: e
      });
      span.finish();
      throw e;
    }
  }
  async get(url, config = {}, flattenArray = false) {
    return await this.request(url, null, "GET", config, flattenArray);
  }
  async post(url, body, config = {}) {
    return await this.request(url, body, "POST", config);
  }
  async patch(url, body, config = {}) {
    return await this.request(url, body, "PATCH", config);
  }
  async put(url, body, config = {}) {
    return await this.request(url, body, "PUT", config);
  }
  async delete(url, body = null, config = {}) {
    return await this.request(url, body, "DELETE", config);
  }
}

export { Api };
